import { render, staticRenderFns } from "./MerchantApplication.vue?vue&type=template&id=444857a6&scoped=true&"
import script from "./MerchantApplication.vue?vue&type=script&lang=js&"
export * from "./MerchantApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444857a6",
  null
  
)

export default component.exports